import { Outlet, createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

import { APP_ROUTES_TO } from "@/utils/routes";

export const SettingsSearchSchema = z.object({
    slack: z.enum(["connected", "error"]).optional(),
});

export type SettingsSearch = z.infer<typeof SettingsSearchSchema>;

export type SlackOAuthStatus = NonNullable<SettingsSearch["slack"]>;

export const Route = createFileRoute(APP_ROUTES_TO.SETTINGS)({
    validateSearch: zodValidator(SettingsSearchSchema),
    component: SettingsLayout,
    staticData: {
        config: {
            title: "settings",
        },
    },
});

function SettingsLayout() {
    return <Outlet />;
}
